import { UIGameToolTipController } from '../../../../shared/scripts/ui_game/ui_game_tooltip/UIGameToolTipController.ts';
import { UIWGameToolTipView } from './UIWGameToolTipView.ts';
import { clientI18n } from '../../../../shared/scripts/ClientI18n.ts';
import { isDescendantOf } from '../../../../shared/scripts/ui_utils/PixiUtils.ts';
export class UIWGameToolTipController extends UIGameToolTipController {
    startedHovering(toolTipText, view) {
        setTimeout(()=>{
            if (this.isCursorOverContainer(view)) this.openTip(toolTipText, view);
        }, this.timeoutToOpenTooltipMS);
    }
    isCursorOverContainer(view) {
        const boundary = this.app.renderer.events.rootBoundary;
        const mouse = this.app.renderer.events.pointer.global;
        const topObject = boundary.hitTest(mouse.x, mouse.y);
        return topObject === view;
    }
    createTip(toolTipText, view) {
        const { title, body } = toolTipText();
        if (clientI18n.t(title.key, title.options) == '' && clientI18n.t(body[0].key, body[0].options) == '') return;
        view.interactive = true;
        view.on('pointerover', (event)=>this.startedHovering(toolTipText, view));
        view.on('pointerout', (event)=>this.closeTip());
    }
    startHoverCheck(view) {
        this.hoverCheckInterval = setInterval(()=>{
            this.hoverCheckCounter += 1;
            const toolTipTooOld = this.hoverCheckCounter > this.hoverCheckCounterThreshold;
            const shouldCloseTip = toolTipTooOld || !this.isCursorOverContainer(view);
            if (shouldCloseTip) this.closeTip();
        }, this.hoverCheckIntervalMS);
    }
    stopHoverCheck() {
        clearInterval(this.hoverCheckInterval);
    }
    disableTip(view) {
        super.disableTip(view);
        view.off('pointerover');
        view.off('pointerout');
    }
    openTip(toolTipText, view) {
        this.closeTip();
        const { title, body, bodyPrefixes } = toolTipText();
        if (!isDescendantOf(view, this.app.stage)) return;
        this.tip = new UIWGameToolTipView(view, title, body, undefined, bodyPrefixes);
        this.startHoverCheck(view);
    }
    closeTip() {
        super.closeTip();
        this.stopHoverCheck();
        this.hoverCheckCounter = 0;
    }
    constructor(...args){
        super(...args), this.hoverCheckCounter = 0, this.hoverCheckIntervalMS = 100, this.timeoutToOpenTooltipMS = 500, this.hoverCheckCounterThreshold = 15 * 1000 / this.hoverCheckIntervalMS;
    }
}
